var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('div',{staticClass:"flex justify-center py-10"},[_c('div',{staticClass:"w-full sm:w-2/3"},[_c('div',{staticClass:"px-2"},[_c('business-create-form')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }